import { useSelector } from "react-redux";

import type { RootState } from "@/lib/types/state";
import { selectTaskIdByType } from "@/redux/selectors/authSelectors";
import type { TaskType, UUID } from "@/core/types";

export function useTaskIdByType(taskType: TaskType): undefined | UUID {
  return useSelector((state: RootState) => selectTaskIdByType(state, taskType));
}
